<template>
    <gofix-card classContent="mb-0" fullContent class="mb-0">
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="addItem"
            @row-click="detailItem"
            @delete-items="deleteItems"
            ref="gofixTable">
        </gofix-table>

        <b-modal :no-close-on-backdrop="true" id="modal-Address" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-10">
                <gofix-form-input label="Name" v-model="modal.data.name"></gofix-form-input>
                <gofix-form-input label="Email" v-model="modal.data.email" required show-icon-required></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" :loading="modal.loading" @click="saveItem" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: "equipment-history",
        components: {},
        data() {
            let filter = JSON.parse(JSON.stringify(filters['supplier_contactable_emails']))
            return {
                tableConfig:{
                    name: 'supplier-contactable-emails',
                    controls:{
                        create: this.$checkRole(this.$accessModule.companies, 'create'),
                        delete: this.$checkRole(this.$accessModule.companies, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    fields: [
                    {
                            key: 'actions',
                            label: "",
                            thStyle: "width: 50px"
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            thStyle: "width: 250px",
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: 'email',
                            label: 'Email',
                            isFilter: true,
                            sorting: true,
                        }
                    ]
                },
                tableItems:[],
                modal: {
                    timer: null,
                    title: '',
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        organisation_id: null,
                        name: null,
                        email: null
                    }
                }
                
            };
        },
        created() {},
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.organisation_id.value = this.$route.params.company_id;
                await this.$store.dispatch("AllCompanyController/getContactableEmailsItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the contactable emails", "danger");
                        reject();
                    })
            },
            addItem() {
                this.modal.title = 'Add Contactable Email'
                this.modal.data = Object.assign(this.modal.data, {
                    id: null,
                    organisation_id: this.$route.params.company_id,
                    name: null,
                    email: null
                })
                this.modal.open = true;
            },
            detailItem(item) {
                if(!this.$checkRole(this.$accessModule.companies, 'update')) return;
                this.modal.title = 'Edit Contactable Email'
                this.modal.data = Object.assign(this.modal.data, {
                    id: item.id,
                    organisation_id: item.organisation_id,
                    name: item.name,
                    email: item.email,
                })
                this.modal.open = true;
            },
            saveItem() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(this.modal.loading) return
                    this.modal.loading = true;
                    let api = 'createContactableEmailItem'
                    let keyMessage = 'adding'
                    if (this.modal.data.id) {
                        keyMessage = 'editing';
                        api = 'updateContactableEmailItem';
                    }
                    
                    this.$store.dispatch(`AllCompanyController/${api}`, this.modal.data).then(async data => {
                        this.modal.loading = this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'supplier_contactable_emails'));
                    })
                    .catch(error => {
                        this.modal.loading = false;
                        if(error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                            this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    });
                }, 500);
            },
            async deleteItems(callback){
                const { ids, filter, resolve, reject } = await callback();
                this.$store.dispatch("AllCompanyController/deleteContactableEmailsItems", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'supplier_contactable_emails'))
                })
                .catch(err => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again")
                });
            }
        }
    }
</script>
